import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewChild } from '@angular/core';
import { StudentSearchService } from "../../Services/StudentSearchService";
import { IStudentSearchResult } from '../../Models/IStudentSearchResult'
import { StudentService } from "../../Services/StudentService";
import { ISelectedStudent } from '../../Models/ISelectedStudent'
import { DashboardDocumentService } from "../../Services/DashboardDocumentService";
import { IDashboardDocument } from '../../Models/IDashboardDocument';
import { ICanAddDocuments } from '../../Models/ICanAddDocuments';
import { Globals } from '../../globals'

@Component({
  selector: 'iep/StudentSearch',
  templateUrl: './StudentSearch.component.html',
})
export class StudentSearchComponent {
  _baseUrl: string;
  _http: HttpClient;
  _myGlobals: Globals;
  _studentSearchService: StudentSearchService;
  _studentService: StudentService;
  _dashboardDocumentService: DashboardDocumentService;

  //SISStudent

  errorMessages: any[] = [];
  successMessages: any[];

  response: string;
  lastName: string;
  firstName: string;
  localStudentId: string;
  ssid: string;
  today: Date;
  dob: Date;
  yearRange: string;

  studentSearchResults: IStudentSearchResult[];
  selectedSearchStudent: IStudentSearchResult;

  constructor(
    http: HttpClient,
    private globals: Globals,
    @Inject('BASE_URL') baseUrl: string,
    studentSearchService: StudentSearchService,
    studentService: StudentService,
    dashboardDocumentService: DashboardDocumentService) {
    this._baseUrl = baseUrl;
    this._http = http;
    this._myGlobals = globals;

    this._studentSearchService = studentSearchService;
    this._studentService = studentService;
    this._dashboardDocumentService = dashboardDocumentService;

    this.today = new Date();
    this.yearRange = (this.today.getFullYear() - 30) + ':' + (this.today.getFullYear());

    this.response = "";
    this.lastName = "";
    this.firstName = "";
    this.localStudentId = "";
    this.ssid = "";
    this.dob = null;
  }

  changeFilter() {
    var dobString: string = '';

    if (this.dob != null) {
      dobString = this.dob.toDateString();
    }

    this._studentSearchService.get(this._baseUrl + 'api/StudentSearch/' + this.lastName + '^' + this.firstName + '^' + dobString + '^' + this.localStudentId + '^' + this.ssid + '^' + this._myGlobals.includeInactiveStudents).subscribe((res: IStudentSearchResult[]) => {
      this.studentSearchResults = res
        , console.log(this.studentSearchResults)
    },
      err => console.error(err)
    );
  }

  documentSelected(selecedDocument: IDashboardDocument) {
    this._myGlobals.selectedDashboardDocument = selecedDocument;
  }

  studentSelected(selectedStudent: IStudentSearchResult) {
    this.selectedSearchStudent = selectedStudent;

    this.lastName = "";
    this.firstName = "";
    this.localStudentId = "";
    this.ssid = "";
    this.dob = null;
    this.studentSearchResults = null;

    this._studentService.get(this._baseUrl + 'api/Student/' + this.selectedSearchStudent.localStudentId).subscribe((res: ISelectedStudent) => {
      this._myGlobals.setSelectedStudent(res),
      this._myGlobals.studentSearchIsVisible = false,
      this._myGlobals.initialIepInfoIsVisible = false,
      console.log(this._myGlobals.selectedStudent)
    },
      err => console.error(err)
    );

    this._dashboardDocumentService.get(this._baseUrl + 'api/DashboardDocument/' + this.selectedSearchStudent.localStudentId).subscribe((res: IDashboardDocument[]) => {
      this._myGlobals.dashboardDocumentResults = res
        , console.log(this._myGlobals.dashboardDocumentResults)
        //, this._myGlobals.documentDashboardIsVisible = true
        //, this._myGlobals.initialIepInfoIsVisible = true;
    },
      err => console.error(err)
    );

    this._dashboardDocumentService.getCanAddDocuments(this._baseUrl + 'api/DashboardDocument/GetCanAddDocuments?localStudentId=' + this.selectedSearchStudent.localStudentId).subscribe((res: ICanAddDocuments) => {
      this._myGlobals.canAddDocuments = res
        , console.log(this._myGlobals.canAddDocuments)
    },
      err => console.error(err)
    );
  }
}
